module.exports = __webpack_public_path__ + "static/media/plus.1cfd55a9.svg";